import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import TimelineForm from './TimelineForm'

const breadcrumbs = [
  {
    id: 1,
    title: 'Histórico',
    path: routes.timeline.path
  },
  {
    id: 2,
    title: 'Nova interação'
  }
]

const TimelineFormContainer = () => {
  const dispatch = useDispatch()
  const store = useSelector((state) => state.timelineReducer)

  const handleSubmit = (values) => {
    dispatch(reducks.resources.timeline.actions.post(values))
  }

  return (
    <DefaultLayout>
      {store.fetching && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100%',
            background: '#FFF',
            left: 0,
            top: 0,
            zIndex: 9,
            opacity: 0.1
          }}
        />
      )}
      <Flex column>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Nova interação
        </Text>
        <Breadcrumb items={breadcrumbs} />

        <TimelineForm handleSubmit={handleSubmit} />
      </Flex>
    </DefaultLayout>
  )
}

export default TimelineFormContainer
